import { render } from "./SignaturePad.vue?vue&type=template&id=e4ce40bc&ts=true"
import script from "./SignaturePad.vue?vue&type=script&lang=ts"
export * from "./SignaturePad.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__